import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyS } from '@sorare/core/src/atoms/typography';
import { Dialog } from '@sorare/core/src/components/dialog';
import { glossary } from '@sorare/core/src/lib/glossary';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

const Root = styled(Vertical).attrs({ gap: 2 })`
  padding: var(--triple-unit) var(--triple-unit) var(--double-unit);
`;
const CautionParagraph = styled(BodyS).attrs({
  as: 'p',
  color: 'var(--c-nd-700)',
})`
  align-self: flex-start;
`;
const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--unit);
  align-items: center;
  & > * {
    width: 100%;
  }
  @media ${laptopAndAbove} {
    flex-direction: row;
    & > * {
      flex: 1;
    }
  }
`;

type Props = {
  open: boolean;
  type: 'noGame' | 'injury';
  onClose: () => void;
  onContinue: () => void;
};
export const EditFirstLineupWarningDialog = ({
  open,
  type,
  onClose,
  onContinue,
}: Props) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      hideHeader
      fullScreen={false}
      footer={
        <ButtonsWrapper>
          <Button size="medium" color="quaternary" onClick={onContinue}>
            <FormattedMessage
              id="EditFirstLineupWarningDialog.continue"
              defaultMessage="Select Anyway"
            />
          </Button>
          <Button size="medium" color="primary" onClick={onClose}>
            <FormattedMessage {...glossary.cancel} />
          </Button>
        </ButtonsWrapper>
      }
    >
      <Root>
        <FontAwesomeIcon icon={faTriangleExclamation} fontSize="24px" />
        <CautionParagraph>
          {type === 'noGame' ? (
            <FormattedMessage
              id="EditFirstLineupWarningDialog.noGame"
              defaultMessage="This player has no match and won’t score points this Game Week."
            />
          ) : (
            <FormattedMessage
              id="EditFirstLineupWarningDialog.injury"
              defaultMessage="This player is currently injured and won’t score points this Game Week."
            />
          )}
        </CautionParagraph>
      </Root>
    </Dialog>
  );
};
